import Dexie, { type EntityTable } from "dexie";
import type {
  AppSettings,
  ExerciseDefinition,
  Program,
  ProgramImportMetadata,
  WorkoutSession,
  WorkoutTemplate,
} from "./types";

export class ForgeDatabase extends Dexie {
  exercises!: EntityTable<ExerciseDefinition, "id">;
  templates!: EntityTable<WorkoutTemplate, "id">;
  programs!: EntityTable<Program, "id">;
  sessions!: EntityTable<WorkoutSession, "id">;
  settings!: EntityTable<AppSettings, "id">;
  imports!: EntityTable<ProgramImportMetadata, "id">;

  constructor(name = "forge-workout") {
    super(name);
    this.version(1).stores({
      exercises: "id, name, archived, updatedAt",
      templates: "id, programId, updatedAt",
      programs: "id, active, updatedAt",
      sessions: "id, workoutTemplateId, status, startedAt, completedAt",
      settings: "id",
      imports: "id, importedAt",
    });
    this.version(2).stores({
      exercises: "id, name, archived, sourceExerciseId, updatedAt",
      templates: "id, programId, updatedAt",
      programs: "id, archived, isCurrent, updatedAt",
      sessions: "id, workoutTemplateId, status, startedAt, completedAt",
      settings: "id",
      imports: "id, importedAt",
    }).upgrade(async (transaction) => {
      await transaction.table("programs").toCollection().modify((program) => {
        program.archived = false;
        program.isCurrent = Boolean(program.active);
      });
      const programCount = await transaction.table("programs").count();
      await transaction.table("settings").toCollection().modify((settings) => {
        settings.onboardingComplete = programCount > 0;
      });
    });
  }
}

export const db = new ForgeDatabase();

export const makeId = (prefix: string) =>
  `${prefix}_${crypto.randomUUID().replaceAll("-", "").slice(0, 16)}`;
